import React from 'react';
import { Link } from 'react-router-dom';
import Seo from '../components/Seo';

const NotFound = () => (
  <>
    <Seo title="Page Not Found" description="The page you're looking for doesn't exist." path="/404" />
    <section className="bg-white/[0.04] py-28 text-center px-4">
      <h1 className="text-6xl font-extrabold text-white mb-4">404</h1>
      <p className="text-lg text-gray-400 mb-8">We couldn't find the page you're looking for.</p>
      <Link to="/" className="px-6 py-3 rounded-full bg-purple-600 text-white font-semibold hover:bg-purple-700 transition-colors">
        Back to Home
      </Link>
    </section>
  </>
);

export default NotFound;
